import { render } from "./GSJJ.vue?vue&type=template&id=5b28151e&scoped=true"
import script from "./GSJJ.vue?vue&type=script&lang=js"
export * from "./GSJJ.vue?vue&type=script&lang=js"

import "./GSJJ.vue?vue&type=style&index=0&id=5b28151e&lang=scss&scoped=true"

import exportComponent from "D:\\大众物流官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b28151e"]])

export default __exports__